var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-list"},[_c('reportcompany',{attrs:{"c_id":1,"is_tab":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }